import React, { useRef, useCallback, useEffect } from "react";
import { useQueryClient } from 'react-query'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {

    faStop,
    faCircle,
    faFutbolBall,
    faVolleyballBall,
    faHockeyPuck,
    faBaseballBatBall,
    faFutbol,
    faExchangeAlt,
    faIdCard,
    faFootballBall,
    faRetweet,
    faStopwatch

} from "@fortawesome/free-solid-svg-icons";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


//import SwiperCore, { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react';
//import { Pagination, Navigation, A11y } from "swiper";

// Import Swiper styles



import SwiperCore, { Pagination, Navigation, A11y, Manipulation } from "swiper";
import Competitor from 'components/presentation/Competitor';
import SportCode from 'components/common/SportCode'
import { NocMemo as Noc } from "components/presentation/Noc";
import { getSportCodeEntityObjects } from 'components/common/SportCode'

// install Swiper modules
SwiperCore.use([Pagination, Navigation, Manipulation]);


export const ICON = {
    CARD: faStop,
    GENERIC_BALL: faCircle,
    FOOTBALL_BALL: faFutbolBall,
    VOLLEY_BALL: faVolleyballBall,
    RUGBY_BALL: faFootballBall,
    CHANGE_IN: faCircle,
    CHANGE_OUT: faCircle,
    CHANGE: faRetweet,
    TIME: faStopwatch,
};

export const COLOUR = {
    BLACK: "icon-black",
    BLUE: "icon-blue",
    GRAY: "icon-gray",
    GREEN: "icon-green",
    ORANGE: "icon-orange",
    RED: "icon-red",
    YELLOW: "icon-yellow",
    WHITE: "icon-white",
};

const singleQuote = "'";

const getConfig = (discipline) => {
    let config
    switch (discipline) {
        case 'FBB':
            config = {
                periodsVisibles: 2,
                timePeriod: 15,
                characterTime: "'",
                timeUp: true,
                timeShow: 1,
                timeBackground: 5,
                resetTimePeriod: false,
                showBib: true,

                actions: [{
                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'SHOT',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {
                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'FRD',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {
                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'PTY',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {
                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: '2PTY',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {
                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.RED,
                    action: 'OG',
                    result: 'GOAL',
                    role: ''
                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.YELLOW,
                    action: 'YC',
                    result: '',
                    role: ''

                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.RED,
                    action: 'RC',
                    result: '',
                    role: ''

                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.RED,
                    action: 'YRC',
                    result: '',
                    role: ''

                },
                {
                    icon: ICON.CHANGE,
                    colour: COLOUR.GREEN,
                    action: 'SUBST',
                    result: '',
                    role: 'IN'

                },
                {
                    icon: ICON.CHANGE,
                    colour: COLOUR.RED,
                    action: 'SUBST',
                    result: '',
                    role: 'OUT'

                }

                ]
            }
            break;
        case 'FBL':
            config = {
                extraTimeDuration: 15,
                extraTimeId: 'OT',
                extraTimeBackground: 5,//Cada cuanto mostramos barras del fondo
                extraTimeShow: 5,//Cada cuanto agrupamos las jugadas

                periodsVisibles: 4,
                timePeriod: 45,
                characterTime: "'",
                timeUp: true,
                timeShow: 5,
                timeBackground: 15,
                resetTimePeriod: false,
                showBib: true,

                actions: [{
                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'SHOT',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {
                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'FRD',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {
                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'PTY',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {
                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.RED,
                    action: 'OG',
                    result: 'GOAL',
                    role: ''
                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.YELLOW,
                    action: 'YC',
                    result: '',
                    role: ''

                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.RED,
                    action: 'RC',
                    result: '',
                    role: ''

                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.RED,
                    action: 'YRC',
                    result: '',
                    role: ''

                },
                {
                    icon: ICON.CHANGE,
                    colour: COLOUR.GREEN,
                    action: 'SUBST',
                    result: '',
                    role: 'IN'

                },
                {
                    icon: ICON.CHANGE,
                    colour: COLOUR.RED,
                    action: 'SUBST',
                    result: '',
                    role: 'OUT'

                }

                ]



            }
            break;
        case 'FEN':
            break;
        case 'HBL':
            config = {
                extraTimeDuration: 5,
                extraTimeId: 'OT',
                extraTimeBackground: 5,//Cada cuanto mostramos barras del fondo
                extraTimeShow: 1,//Cada cuanto agrupamos las jugadas

                periodsVisibles: 4,
                timePeriod: 30,
                characterTime: ":",
                timeUp: true,
                timeShow: 1,
                timeBackground: 10,
                resetTimePeriod: false,
                showBib: true,

                actions: [{
                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'SHOT',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.YELLOW,
                    action: 'YC',
                    result: '',
                    role: ''
                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.RED,
                    action: 'RC',
                    result: 'D',
                    role: ''
                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.BLUE,
                    action: 'EXC',
                    result: '',
                    role: ''
                },
                {
                    icon: ICON.TIME,
                    colour: COLOUR.GRAY,
                    action: 'TMS',
                    result: '',
                    role: ''
                },
                {
                    icon: ICON.TIME,
                    colour: COLOUR.GRAY,
                    action: 'TPT',
                    result: '',
                    role: ''
                },
                {
                    icon: ICON.TIME,
                    colour: COLOUR.RED,
                    action: 'RC',
                    result: 'X',
                    role: ''
                }


                ]
            }
            break;
        case 'HOC':
            config = {

                periodsVisibles: 4,
                timePeriod: 15,
                characterTime: "'",
                timeUp: true,
                timeShow: 1,
                timeBackground: 5,
                resetTimePeriod: false,

                actions: [{
                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'SHOT',
                    result: 'GOAL',
                    role: ''
                },
                {
                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'SHOT_PC',
                    result: 'GOAL',
                    role: ''
                },
                {
                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'PTY',
                    result: 'GOAL',
                    role: ''
                },
                {
                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'OG',
                    result: 'GOAL',
                    role: ''
                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.YELLOW,
                    action: 'YC',
                    result: '',
                    role: ''

                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.RED,
                    action: 'RC',
                    result: '',
                    role: ''

                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.GREEN,
                    action: 'GC',
                    result: '',
                    role: ''
                }

                ]
            }
            break;
        case 'RU7':
            config = {

                extraTimeDuration: 5,
                extraTimeId: 'OT',
                extraTimeBackground: 5,//Cada cuanto mostramos barras del fondo
                extraTimeShow: 1,//Cada cuanto agrupamos las jugadas

                periodsVisibles: 4,
                timePeriod: 7,
                characterTime: ":",
                timeUp: true,
                timeShow: 1,
                timeBackground: 7,
                resetTimePeriod: true,

                actions: [{
                    icon: ICON.RUGBY_BALL,
                    colour: COLOUR.GRAY,
                    action: 'CONV',
                    result: 'GOAL',
                    role: ''
                },
                {
                    icon: ICON.RUGBY_BALL,
                    colour: COLOUR.GRAY,
                    action: 'TRY',
                    result: 'GOAL',
                    role: ''
                },
                {
                    icon: ICON.RUGBY_BALL,
                    colour: COLOUR.GRAY,
                    action: 'PTY',
                    result: 'GOAL',
                    role: ''
                },
                {
                    icon: ICON.RUGBY_BALL,
                    colour: COLOUR.GRAY,
                    action: 'PTRY',
                    result: 'GOAL',
                    role: ''
                },
                {
                    icon: ICON.RUGBY_BALL,
                    colour: COLOUR.GRAY,
                    action: 'DROP',
                    result: 'GOAL',
                    role: ''
                },
                {
                    icon: ICON.CHANGE_IN,
                    colour: COLOUR.GREEN,
                    action: 'SUBST',
                    result: '',
                    role: 'IN'
                },
                {
                    icon: ICON.CHANGE_OUT,
                    colour: COLOUR.RED,
                    action: 'SUBST',
                    result: '',
                    role: 'OUT'
                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.YELLOW,
                    action: 'YC',
                    result: '',
                    role: ''

                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.RED,
                    action: 'RC',
                    result: '',
                    role: ''
                }
                ]
            }
            break;
        case 'WPO':
            config = {
                periodsVisibles: 4,
                timePeriod: 8,
                characterTime: ":",
                timeUp: false,
                timeShow: 1,
                timeBackground: 4,
                resetTimePeriod: true,
                showBib: true,
                showNoc: true,
                actions: [{

                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'MFT',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {

                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'PTY',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {

                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'ACT',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {

                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'CAT',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {

                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'CNT',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {

                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'CRN',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {

                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'EFT',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {

                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'DRW',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {

                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'DRX',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {

                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'EXT',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {

                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'DFT',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {

                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'FRP',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {

                    icon: ICON.GENERIC_BALL,
                    colour: COLOUR.GRAY,
                    action: 'DRV',
                    result: 'GOAL',
                    role: 'SCR'
                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.YELLOW,
                    action: 'YC',
                    result: '',
                    role: ''

                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.YELLOW,
                    action: 'CYC',
                    result: '',
                    role: ''

                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.RED,
                    action: 'RC',
                    result: '',
                    role: ''
                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.RED,
                    action: 'CRC',
                    result: '',
                    role: ''
                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.RED,
                    action: '2EXC',
                    result: '',
                    role: ''

                },
                {
                    icon: ICON.CARD,
                    colour: COLOUR.GREEN,
                    action: 'GC',
                    result: '',
                    role: ''

                }


                ]



            }
            break;
        default:
            break;
        // code block
    }

    return config
}

function useGetData(queryName) {
    const { mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    let query = queryName || ['resultsDataH2H', mirs_competition, mirs_rsc, mirs_language]
    const queryClient = useQueryClient();
    const data = queryClient.getQueryData(query);
    return data
}

function getParticipants(data) {
    /** Saber quien es Home Away  */
    let homeRaw = data?.results?.items?.find(item =>
        item?.eventUnitEntries?.find(euItem => euItem.eue_code === 'HOME_AWAY' && euItem.eue_value === 'HOME')
    )
    // there is NO event unit entry HOME_AWAY, then guess that HOME is the one's with startSortOrder = 1
    if (homeRaw === undefined) {
        homeRaw = data?.results?.items?.find(item => item.startSortOrder === 1)
    }

    let awayRaw = data?.results?.items?.find(item =>
        item?.eventUnitEntries?.find(euItem => euItem.eue_code === 'HOME_AWAY' && euItem.eue_value === 'AWAY')
    )
    // there is NO event unit entry HOME_AWAY, then guess that HOME is the one's with startSortOrder = 1
    if (awayRaw === undefined) {
        awayRaw = data?.results?.items?.find(item => item.startSortOrder === 2)
    }

    const homeAway = {
        home: { team: homeRaw?.participant, athletes: homeRaw?.teamAthletes },
        away: { team: awayRaw?.participant, athletes: awayRaw?.teamAthletes }
    }

    return (homeAway)
}

function ActionLineBackground({ period }) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let actionArray = []

    //Configurations
    let config = getConfig(mirs_discipline)
    let numBlocks = config.timePeriod / config.timeBackground


    let periodDelay
    let periodEnd

    if (config.resetTimePeriod) {
        periodDelay = 0;
        periodEnd = config.timePeriod;
    } else {
        periodDelay = period * config.timePeriod;
        periodEnd = (period + 1) * config.timePeriod;
    }


    for (let block = 0; block <= numBlocks; block++) {
        let minute = block * config.timeBackground;

        let minuteLabel
        if (config.timeUp) {
            minuteLabel = minute + periodDelay;
        } else {
            let minuteB = (numBlocks - block) * config.timeBackground;
            minuteLabel = minuteB - periodDelay;
            periodEnd = 0;
        }


        let minutePercent = minute * 100 / config.timePeriod + "%"
        if (minutePercent !== '100%') {
            actionArray.push(
                <li key={'actionline-background-' + block} style={{ left: minutePercent }}><span className='b-minute'>{minuteLabel}'</span></li>
            )
        }
    }

    actionArray.push(
        <li key={'actionline-background-end'} style={{ left: '100%' }}><span className='b-minute'>{periodEnd}'</span></li>
    )

    return (
        <ul className="time-interval">
            {actionArray.map(action => action)}

        </ul>
    )


}

function ActionLineBackgroundExtraTime({ period, periodsET, numPeriods }) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let actionArray = []
    //Configurations
    let config = getConfig(mirs_discipline)
    let numBlocks = config.extraTimeDuration / config.extraTimeBackground
    let periodDelay
    let periodEnd

    let periodNoOT = numPeriods - periodsET
    let etPeriod = period - periodNoOT

    if (config.resetTimePeriod) {
        periodDelay = 0
        periodEnd = config.timePeriod;
    } else {
        periodDelay = (periodNoOT * config.timePeriod) + (etPeriod * config.extraTimeDuration)
        periodEnd = (periodDelay + config.extraTimeDuration);
    }

    for (let block = 0; block <= numBlocks; block++) {
        let minute = block * config.extraTimeBackground

        let minuteLabel
        if (config.timeUp) {
            minuteLabel = minute + periodDelay
        } else {
            minuteLabel = minute - periodDelay
        }

        let minutePercent = minute * 100 / config.extraTimeDuration + "%"

        if (minutePercent !== '100%') {
            actionArray.push(
                <li key={'actionline-background-extra-' + block} style={{ left: minutePercent }}><span className='b-minute'>{minuteLabel}'</span></li>
            )
        }
    }

    actionArray.push(
        <li key={'actionline-background-extra-end'} style={{ left: '100%' }}><span className='b-minute'>{periodEnd}'</span></li>
    )





    return (
        <ul className="time-interval">
            {actionArray.map(action => action)}

        </ul>
    )


}

function getIcon(config, action, result) {

    let res = result !== undefined ? result : ''
    let act = config?.actions?.find(item => {
        return (
            item.action === action
            && item.result === res?.trim()

        )
    }
    )

    return (
        {
            icon: act?.icon,
            colour: act?.colour
        }
    )
}

function ActionBlock({ homeAway, period, actions, home, cumWidth }) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let actionArray = []
    //Configurations
    let config = getConfig(mirs_discipline)
    let numBlocks = config.timePeriod / config.timeShow
    let periodDelay
    if (config.resetTimePeriod) {
        periodDelay = 0
    } else {
        periodDelay = period * config.timePeriod
    }

    for (let block = 0; block <= numBlocks; block++) {
        let blockActions = actions && actions.filter(action => {
            let posCharacter = action?.pbpa_When?.indexOf(config.characterTime);
            let minute = Number(action?.pbpa_When?.substring(0, posCharacter));

            if (config.timeUp) {
                minute = minute - periodDelay
            } else {
                minute = minute + periodDelay
            }
            const boolean1 = minute <= block * config.timeShow;
            const boolean2 = minute > (block - 1) * config.timeShow;
            return (
                boolean1 && boolean2 ? action : null

            )
        }

        )

        let blockActionsFilter = []
        Array.isArray(blockActions) && blockActions.forEach(action => {
            let result = action?.pbpa_Result ? action?.pbpa_Result : ''
            if (config?.actions?.find(item =>
                item.action === action.pbpa_Action
                && item.result === result
            )) {
                blockActionsFilter.push(action)
            }
        })

        if (blockActionsFilter.length > 0) {
            actionArray.push(
                {
                    block: block,
                    actions: blockActionsFilter
                }
            )
        }
    }




    let list = actionArray.map((action, index) => {
        let minute = action.block * config.timeShow
        let minutePercentData = minute * 100 / config.timePeriod
        let minutePercent //= minutePercentData + "%"

        if (config.timeUp) {
            minutePercent = minutePercentData + "%"
            minute = minute + periodDelay
        } else {
            minutePercent = (100 - minutePercentData) + "%"
            minute = minute - periodDelay
        }
        let act = getIcon(config, action?.actions[0]?.pbpa_Action, action?.actions[0]?.pbpa_Result)
        let icon = act?.icon
        let colour = act?.colour
        if (action.actions.length > 1) {
            icon = ICON.CARD
            colour = COLOUR.BLACK

        }

        let directionBySize = cumWidth > 50 ? 's-direction-left ' : 's-direction-right';
        return (
            <div key={'actionblock-' + period + '-' + minute + '-' + (home ? 'home' : 'away') + index} className="s-event" style={{ left: minutePercent }}>
                <span className="s-event-time text-middle">{minute}{singleQuote}</span>
                <span><FontAwesomeIcon className={`s-event-type-icon ${colour}`} icon={icon} /></span>
                {/*</div><div className={`s-dropdown  ${!period / 2 === 0 ? "s-direction-left " : "s-direction-right"}`} >*/}
                {/*<div className={`s-dropdown  ${minutePercentData > 50 ? "s-direction-left " : "s-direction-right"}`} >*/}
                <div className={`s-dropdown  ${directionBySize}`} >
                    <ActionsList actions={action.actions} homeAway={homeAway} home={home} config={config} />
                </div>

            </div>

        )
    }
    )

    return (<>{list}</>
    )

}

function ActionBlockExtraTime({ homeAway, period, actions, home, cumWidth }) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let actionArray = []
    //Configurations
    let config = getConfig(mirs_discipline)
    let numBlocks = config.extraTimeDuration / config.extraTimeShow
    let periodDelay
    if (config.resetTimePeriod) {
        periodDelay = 0
    } else {
        periodDelay = period * config.timePeriod //Falta sumar periodos extra time
    }

    for (let block = 0; block <= numBlocks; block++) {
        let blockActions = actions && actions.filter(action => {
            let posCharacter = action?.pbpa_When?.indexOf(config.characterTime);
            let minute = Number(action?.pbpa_When?.substring(0, posCharacter));

            if (config.timeUp) {
                minute = minute - periodDelay
            } else {
                minute = minute + periodDelay
            }

            const boolean1 = minute <= block * config.extraTimeShow
            const boolean2 = minute > (block - 1) * config.extraTimeShow

            return (
                boolean1 && boolean2 ? action : null

            )
        }

        )

        let blockActionsFilter = []
        blockActions.forEach(action => {
            let result = action?.pbpa_Result ? action?.pbpa_Result : ''
            if (config?.actions?.find(item =>
                item.action === action.pbpa_Action
                && item.result === result
            )) {
                blockActionsFilter.push(action)
            }
        })

        if (blockActionsFilter.length > 0) {
            actionArray.push(
                {
                    block: block,
                    actions: blockActionsFilter
                }
            )
        }
    }




    let list = actionArray.map((action, index) => {
        let minute = action.block * config.extraTimeShow
        let minutePercentData = minute * 100 / config.extraTimeDuration
        let minutePercent //= minutePercentData + "%"

        if (config.timeUp) {
            minutePercent = minutePercentData + "%"
            minute = minute + periodDelay
        } else {
            minutePercent = (100 - minutePercentData) + "%"
            minute = minute - periodDelay
        }

        let act = config?.actions?.find(item => {
            let result = action.actions[0]?.pbpa_Result !== undefined ? action.actions[0]?.pbpa_Result : ''
            return (
                item.action === action.actions[0]?.pbpa_Action
                && item.result === result.trim()
                // && item.role === role
            )
        }
        )
        let icon = act?.icon
        let colour = act?.colour


        if (action.actions.length > 1) {
            icon = ICON.CARD
            colour = COLOUR.BLACK

        }


        return (
            <div key={'actionblock-extratime-' + period + '-' + minute + '-' + (home ? 'home' : 'away') + index} className="s-event" style={{ left: minutePercent }}>
                <span className="s-event-time text-middle">{minute}'</span>
                <span><FontAwesomeIcon className={`s-event-type-icon ${colour}`} icon={icon} /></span>
                {/*</div><div className={`s-dropdown  ${!period / 2 === 0 ? "s-direction-left " : "s-direction-right"}`} >
                <div className={`s-dropdown  ${minutePercentData > 50 ? "s-direction-left " : "s-direction-right"}`} >*/}
                <div className={`s-dropdown  ${cumWidth > 50 ? "s-direction-left " : "s-direction-right"}`} >
                    <ActionsList actions={action.actions} homeAway={homeAway} home={home} config={config} />
                </div>

            </div>

        )
    }
    )

    return (<>{list}</>
    )









}


function ActionsList({ actions, home, homeAway, config }) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let participants
    if (home) {
        participants = homeAway?.home
    } else {
        participants = homeAway?.away

    }
    return (
        actions.map((action, index) => {
            const comp = action?.competitors?.find(item => {
                return (
                    item.pbpc_code === participants?.team?.code
                )
            })
            let act = getIcon(config, action?.pbpa_Action, action?.pbpa_Result)
            let icon = act?.icon
            let colour = act?.colour

            return (
                <div key={'action-list-extratime-' + action?.pbpa_order} className="s-single-action text-start  " >
                    <span className="s-icon">
                        <span><FontAwesomeIcon className={`s-event-type-icon ${colour}`} icon={icon} /></span>
                    </span>
                    <span className="s-time">
                        {action.pbpa_When}
                    </span>
                    <span className="s-action">
                        <SportCode discipline={mirs_discipline} entity='@Action' code={action?.pbpa_Action} />&nbsp;
                        <SportCode discipline={mirs_discipline} entity='@ResAction' code={action?.pbpa_Result} />&nbsp;
                    </span>
                    <span className="s-description">
                        <RenderCompetitor comp={comp} participants={participants} action={action} config={config} />
                    </span>
                </div>
            )
        })
    )
}


const RenderCompetitor = ({ comp, participants, action, config }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    if (comp?.athletes) {
        return comp?.athletes?.map((ath) => {

            let competitorComponent
            if (action?.pbpa_Action === 'SUBST' || ath.pbpat_role === 'ASSIST') {
                competitorComponent = <div className="s-group"><span className="s-role"> <SportCode discipline={mirs_discipline} entity='@ActionRole' code={ath.pbpat_role} /> </span> <RenderAthlete code={ath.pbpat_code} participants={participants} config={config} /></div>
            } else {
                competitorComponent = <RenderAthlete code={ath.pbpat_code} participants={participants} config={config} />
            }



            return (
                <React.Fragment key={action?.pbpa_id + ath?.pbpat_code}>
                    {competitorComponent}
                </React.Fragment>
            );
        });
    } else {
        return (

            <Competitor noLink={true} hideNoc={true} hidePicture={true} alwaysNoc={true} {...participants?.team} />

        )
    }
}

const RenderAthlete = ({ code, participants, config }) => {
    const ath = participants?.athletes?.find(item => item?.athlete?.code === code);

    let out = <Competitor noLink={true} hideNoc={true} hidePicture={true} alwaysNoc={true} {...ath?.athlete} />
    if (config.showBib || config.showNoc) {
        out = (
            <div className="d-flex">
                {config.showBib && <div className="pe-1 fw-bold">{ath?.bib + ' '}</div>}
                {config.showNoc && <Noc {...ath?.athlete.organisation} />}
                <Competitor noLink={true} hideNoc={true} hidePicture={true} alwaysNoc={true} {...ath?.athlete} />
            </div>
        );
    }


    return (<>{out}</>
    )
}

const ActionLine = ({ queryName }) => {
    const { mirs_discipline, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    const data = useGetData(queryName);
    const actions = data?.results?.playByPlay?.filter(item => item.subcode !== 'PSO' && item.subcode !== 'OT' && item.subcode !== 'TOT')
    const homeAway = getParticipants(data)
    const config = getConfig(mirs_discipline)
    const sliderRef = useRef(null);
    const btnPrev = useRef(null);
    const btnNext = useRef(null);

    const queryClient = useQueryClient();
    const dataSportCodes = queryClient.getQueryData(["SportCodes", mirs_competition, mirs_language])?.sportCodes;
    const periodsCodes = getSportCodeEntityObjects(dataSportCodes, mirs_discipline, '@Period');
    const periodsOrder = periodsCodes ? periodsCodes?.map(p => ({ period: p.sportCode, order: parseInt(p.order) }))?.sort((a, b) => a.order - b.order) : [];




    useEffect(() => {
        onSlideChange()
    }, []);

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
    }, []);

    const onSlideChange = useCallback(() => {
        // left postion
        if (sliderRef.current.swiper.activeIndex === 0) {
            btnPrev.current.style = 'visibility: hidden';
            btnNext.current.style = 'visibility: visible';
        }
        // right postion
        else if (sliderRef.current.swiper.activeIndex === sliderRef.current.swiper.slides.length - 2) {
            btnPrev.current.style = 'visibility: visible';
            btnNext.current.style = 'visibility: hidden';
        }
        // middle positions
        else {
            btnPrev.current.style = 'visibility: visible';
            btnNext.current.style = 'visibility: visible';
        }
    }, []);

    let timeMatch = data?.results?.clock?.time
    let posCharacter = timeMatch?.indexOf(':');
    let currentTime = Number(timeMatch?.substring(0, posCharacter));
    let periodSC = periodsCodes.find(item => item.sportCode === data?.results?.clock?.period)
    let currentPeriod = periodSC?.order//data?.results?.clock?.period?.replace(/\D/g, '');


    //Actions calculo porcentajes Sliders width 
    // Periodo normal Slider = 1
    // Extratime % conrespecto al periodo normal 0.
    let w1 = 0
    let extraTimePercentPeriod = (config.extraTimeDuration / config.timePeriod)

    /*
        actions && actions.forEach((period) => {
            let isExtraTime = period?.subcode.startsWith("OT") || period?.subcode.startsWith("ET");
            let _width = isExtraTime ? extraTimePercentPeriod : 1;
            return (w1 = w1 + _width)
        });
    */


    let periodsFilter = periodsOrder.filter(period =>
        !period?.period.startsWith("OT") &&
        !period?.period.startsWith("ET") &&
        period?.period !== 'PSO' &&
        period?.period !== 'TOT' &&
        period?.period !== 'HT' &&
        period?.period !== 'FT'

    )
    let hasET = actions?.find(p => p?.subcode?.startsWith("OT") || p?.subcode.startsWith("ET"))
    let actionPeriods = []
    if (hasET) {
        actions && actions.forEach((period) => {
            actionPeriods.push(period.subcode)
        });

        periodsFilter = periodsOrder.filter(period => actionPeriods.includes(period?.period))
    }



    periodsFilter && periodsFilter.forEach((period) => {
        let isExtraTime = period?.period.startsWith("OT") || period?.period.startsWith("ET");
        let _width = isExtraTime ? extraTimePercentPeriod : 1;
        return (w1 = w1 + _width)
    });


    let cumWidth = 0;
    let numPeriodsExtraTime = 0
    let numPeriods = 0

    if (actions) {
        numPeriods = actions.length
        numPeriodsExtraTime = actions.filter(period => period?.subcode.startsWith("OT") || period?.subcode.startsWith("ET")).length
    }


    return (
        <>
            <div className="mirs-action-line d-none d-md-flex">
                <div className="prev-arrow" ref={btnPrev} onClick={handlePrev} >Prev</div>

                <div className="flags-block">

                    <div className="flag-margin"><Noc {...homeAway?.home?.team?.organisation} />  </div>
                    <div><Noc {...homeAway?.away?.team?.organisation} />  </div>
                </div>
                <Swiper className="swiper-action-line"
                    onSlideChange={() => onSlideChange()}
                    ref={sliderRef}
                    //slidesPerView={2}
                    slidesPerView={'auto'}
                    //navigation={true}
                    pagination={{ clickable: true, }}
                    modules={[Pagination, Navigation, A11y]}
                    //slidesPerView={1}
                    observer={true}
                    watchSlidesProgress={true}
                //spaceBetween={'50'}
                >
                    {

                        periodsFilter && periodsFilter.map((periodOrder, index) => {
                            let period = actions?.find(p => p.subcode === periodOrder.period)
                            let actionsHome =
                                period?.actions?.filter(action =>
                                    (action?.competitors?.find(comp => comp?.pbpc_code === homeAway?.home?.team?.code)) ? action : null
                                )
                            let actionsAway =
                                period?.actions?.filter(action =>
                                    (action?.competitors?.find(comp => comp?.pbpc_code === homeAway?.away?.team?.code)) ? action : null
                                )

                            //Periods Visible
                            // let widthPeriod = 100 / actions.length + "%"  // 100 / config.periodsVisibles + "%"
                            // let extraTimeWidthPeriod = (config.extraTimeDuration * 100 / config.timePeriod) / actions.length + "%" //(config.extraTimeDuration * 100 / config.timePeriod) / config.periodsVisibles + "%"
                            let isExtraTime = period?.subcode?.startsWith("OT") || period?.subcode?.startsWith("ET");
                            let _width = isExtraTime ? ((extraTimePercentPeriod * 100) / w1) + "%" : ((1 * 100) / w1) + "%"

                            let _widthPeriod = isExtraTime ? ((extraTimePercentPeriod * 100) / w1) : ((1 * 100) / w1)
                            cumWidth = cumWidth + _widthPeriod
                            let background
                            if (isExtraTime) {
                                background = <ActionLineBackgroundExtraTime period={index} periodsET={numPeriodsExtraTime} numPeriods={numPeriods} />
                            } else {
                                background = < ActionLineBackground period={index} />
                            }
                            let ActionsComponent
                            if (isExtraTime) {
                                ActionsComponent = ActionBlockExtraTime
                            } else {
                                ActionsComponent = ActionBlock
                            }
                            //Progression Bar time played
                            let bar
                            let minute
                            let minutePercentData

                            if (index + 1 < currentPeriod) {
                                bar = <div className="s-progress" style={{ width: "100%" }}></div>
                            }
                            if ((index + 1) === Number(currentPeriod)) {
                                if (!isExtraTime) {
                                    if (config.resetTimePeriod === true && config.timeUp === false) {
                                        minute = config.timePeriod - currentTime
                                    }

                                    if (config.resetTimePeriod === true && config.timeUp === true) {
                                        minute = currentTime
                                    }

                                    if (config.resetTimePeriod === false && config.timeUp === true) {
                                        minute = currentTime - (index * config.timePeriod)
                                        if (minute > config.timePeriod) { minute = config.timePeriod }
                                    }
                                    minutePercentData = minute * 100 / config.timePeriod

                                } else {
                                    let regularPeriods = numPeriods - numPeriodsExtraTime
                                    if (config.resetTimePeriod === true && config.timeUp === false) {
                                        minute = config.extraTimeDuration - currentTime
                                    }

                                    if (config.resetTimePeriod === true && config.timeUp === true) {
                                        minute = currentTime
                                    }

                                    if (config.resetTimePeriod === false && config.timeUp === true) {
                                        let regularTime = regularPeriods * config.timePeriod
                                        let extratime = (index - regularPeriods) * config.extraTimeDuration

                                        minute = currentTime - (regularTime + extratime)
                                        if (minute > config.timePeriod) { minute = config.extraTimeDuration }
                                    }
                                    minutePercentData = minute * 100 / config.extraTimeDuration
                                }


                                let minutePercent = minutePercentData + "%"
                                bar = <div title={currentTime} className="s-progress" style={{ width: minutePercent }}></div>

                            }
                            if (index + 1 > currentPeriod) {
                                bar = <div className="s-progress" style={{ width: "0%" }}></div>
                            }

                            //Add Slides
                            return (

                                <SwiperSlide key={'slide-period-' + index} className="period" style={{ width: _width }}>
                                    <div className="s-timeline-container">
                                        <div className="period-indicator"><SportCode discipline={mirs_discipline} entity='@Period' code={periodOrder.period} abbr={true} />  </div>
                                        <div className="s-timeline-bar">
                                            {/*<div className="s-circle is-started">{period?.subcode} </div>*/}
                                            <div className="s-bar">
                                                {background}
                                                <div className="s-background" style={{ width: "100%" }}></div>
                                                {bar}
                                            </div>
                                        </div>

                                        <div className="s-events s-events--team1">
                                            <ActionsComponent period={index} actions={actionsHome} home={true} homeAway={homeAway} cumWidth={cumWidth} />
                                        </div>

                                        <div className="s-events s-events--team2">
                                            <ActionsComponent period={index} actions={actionsAway} home={false} homeAway={homeAway} cumWidth={cumWidth} />
                                        </div>
                                    </div>
                                </SwiperSlide>
                            )
                        })
                    }
                </Swiper>
                <div className="next-arrow" ref={btnNext} onClick={handleNext} >Next</div>
            </div>
        </>
    );
};

export default ActionLine

